import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

export const SelectContainer = styled('div')({
  width: 216,
  '&:hover': {
    cursor: 'pointer'
  },
  '@media only screen and (min-width: 600px) and (max-width: 767px)': {
    display: 'none'
  }
});

export const StyledTextField = styled(TextField)({
  '& .MuiOutlinedInput-input': {
    display: 'flex',
    padding: 0,
    minHeight: 54,
    height: 'auto',
    width: 160,
    justifyContent: 'center',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    boxShadow: '0px 1px 2px rgb(0 0 0 / 16%), 0px 2px 4px rgb(0 0 0 / 12%), 0px 1px 8px rgb(0 0 0 / 10%)',
    borderRadius: 8,
    '&:hover': {
      cursor: 'pointer'
    }
  }
});

export const StyledValueContainer = styled('div')({
  textAlign: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  flex: 1,
  overflowScrolling: 'touch',
  position: 'relative',
  overflow: 'hidden',
  boxSizing: 'border-box',
  maxWidth: 88,
  '& input::placeholder': {
    opacity: 1,
    color: '#263238'
  }
});

export const StyledPlaceholder = styled('div')({
  opacity: 1,
  color: '#263238'
});
